import React, { FunctionComponent } from 'react';

import { Translate } from 'react-localize-redux';

import styled from 'styled-components';

import Flex from '@components/layout/flex';
import Avatar from '@components/basics/avatar';
import Typography from '@components/basics/typography';

interface ArtistInfoAvatarProps {
  className?: string;
  src: string;
  name: string;
  releases: number;
}

const ArtistInfoAvatar: FunctionComponent<ArtistInfoAvatarProps> = ({
  className,
  src,
  name,
  releases,
}) => {
  return (
    <Flex className={className || ''} alignItems="center">
      <Avatar className="avatar" src={src} alt={`${name}-avatar`} />
      <div>
        <Typography className="title" type="big-title" customFont="medium">
          {name}
        </Typography>
        <SecondaryText type="paragraph">
          <Translate
            id={
              releases === 1
                ? 'ARTIST.DEACTIVATE.USER_INFO.RELEASE'
                : 'ARTIST.DEACTIVATE.USER_INFO.RELEASES'
            }
            data={{ releases: releases }}
          />
        </SecondaryText>
      </div>
    </Flex>
  );
};

export default styled(ArtistInfoAvatar)`
  .avatar {
    margin-right: 10px;
  }
  .title {
    margin-bottom: 3px;
  }
`;

const SecondaryText = styled(Typography)`
  text-transform: capitalize;
  color: ${({ theme }) => theme.colors.tertiary};
  opacity: 1;
`;
